import React from 'react';
import './HeroSection.css';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

function HeroSection() {
  return (
    <section className="hero">
      {/* <div className="hero-content">
        <h1>Empowering Businesses with Innovation and Technology</h1>
        <p>Transform your business with cutting-edge IT solutions, AI-driven technologies, and expert consulting.</p>
        <Link to="/contact" className="cta-button">Get Started</Link>
      </div> */}
    </section>
  );
}

export default HeroSection;